exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-form[data-v-4cf2cfa6]{background-color:#fff}.icon-style[data-v-4cf2cfa6]{font-size:3rem!important}.color-text-default[data-v-4cf2cfa6]{color:#707070}", ""]);

// exports
